function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "89.7,87.6 76.2,87.6 76.2,84.6 86.7,84.6 86.7,3.2 22.5,3.2 22.5,13.7 19.5,13.7 19.5,0.2 89.7,0.2  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M77.7,99.7H7.4V12.2h70.2V99.7z M10.4,96.7h64.2V15.2H10.4V96.7z"
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M31.4,35.2H19.5V23.4h11.8V35.2z M22.5,32.2h5.8v-5.8h-5.8V32.2z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 36.2,
  y: 23.4,
  width: 26.9,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 36.2,
  y: 30,
  width: 15,
  height: 3
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M31.4,52.6H19.5V40.8h11.8V52.6z M22.5,49.6h5.8v-5.8h-5.8V49.6z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 36.2,
  y: 40.8,
  width: 26.9,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 36.2,
  y: 47.4,
  width: 15,
  height: 3
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M31.4,70H19.5V58.2h11.8V70z M22.5,67h5.8v-5.8h-5.8V67z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 36.2,
  y: 58.2,
  width: 26.9,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 36.2,
  y: 64.8,
  width: 15,
  height: 3
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M31.4,87.4H19.5V75.5h11.8V87.4z M22.5,84.4h5.8v-5.8h-5.8V84.4z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 36.2,
  y: 75.5,
  width: 26.9,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 36.2,
  y: 82.2,
  width: 15,
  height: 3
}))))));

var SvgListTwo = function SvgListTwo(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/list-two.a9099fe2.svg";
export { SvgListTwo as ReactComponent };